var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        "close-on-click-modal": false,
        "lock-scroll": true,
        "modal-append-to-body": "",
        "append-to-body": "",
        width: "950px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _c("span", {
          staticClass: "block",
          style: { backgroundColor: _vm.blockColor },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "title-text" }, [
          _vm._v(_vm._s(_vm.detail.typeName || _vm.todayDetailData.title)),
        ]),
        _vm._v(" "),
        _vm.id != -1
          ? _c(
              "span",
              { staticClass: "title-message" },
              [
                _vm._v(
                  _vm._s(_vm.detail.create_user_name) +
                    " 创建于 " +
                    _vm._s(_vm.timeFormatted(_vm.detail.create_time)) +
                    "\n      "
                ),
                _c(
                  "el-dropdown",
                  {
                    attrs: { trigger: "click" },
                    on: { command: _vm.handleTypeDrop },
                  },
                  [
                    _c("el-button", { attrs: { icon: "el-icon-more" } }),
                    _vm._v(" "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      _vm._l(_vm.moreTypes, function (item, index) {
                        return _c(
                          "el-dropdown-item",
                          { key: index, attrs: { command: item.type } },
                          [_vm._v(_vm._s(item.title))]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "scroll_content",
        },
        [
          _vm.id == -1
            ? [
                _c(
                  "el-table",
                  {
                    staticClass: "n-table--border",
                    staticStyle: { width: "100%" },
                    attrs: {
                      id: "crm-table",
                      data: _vm.list,
                      "cell-class-name": _vm.cellClassName,
                      height: "450",
                      stripe: "",
                      border: "",
                      "highlight-current-row": "",
                    },
                    on: { "row-click": _vm.handleRowClick },
                  },
                  [
                    _vm._l(_vm.fieldList, function (item, index) {
                      return _c("el-table-column", {
                        key: index,
                        attrs: {
                          prop: item.prop,
                          label: item.label,
                          "min-width": item.width,
                          formatter: _vm.fieldFormatter,
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  item.prop == "deal_status"
                                    ? [
                                        _c("i", {
                                          class: _vm._f("dealIcon")(
                                            scope.row[item.prop]
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("dealName")(
                                                scope.row[item.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    : item.prop == "status" &&
                                      _vm.crmType === "customer"
                                    ? [
                                        scope.row.status == 2
                                          ? _c("i", {
                                              staticClass:
                                                "wk wk-circle-password customer-lock",
                                            })
                                          : _vm._e(),
                                      ]
                                    : item.prop == "check_status"
                                    ? [
                                        _c("span", {
                                          staticClass: "status-mark",
                                          style: _vm.getStatusStyle(
                                            scope.row.check_status
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getStatusName(
                                                scope.row.check_status
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    : [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(scope.row[item.prop]) +
                                            "\n            "
                                        ),
                                      ],
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    }),
                    _vm._v(" "),
                    _c("el-table-column", { attrs: { resizable: false } }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "p-contianer" },
                  [
                    _c("el-pagination", {
                      staticClass: "p-bar",
                      attrs: {
                        "current-page": _vm.currentPage,
                        "page-sizes": _vm.pageSizes,
                        "page-size": _vm.pageSize,
                        total: _vm.total,
                        background: "",
                        layout: "prev, pager, next, sizes, total, jumper",
                      },
                      on: {
                        "update:pageSize": function ($event) {
                          _vm.pageSize = $event
                        },
                        "update:page-size": function ($event) {
                          _vm.pageSize = $event
                        },
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "div",
                  { staticClass: "common-box" },
                  [
                    _c("div", { staticClass: "common-title" }, [
                      _vm._v(
                        _vm._s(_vm.todayDetailData.title || _vm.detail.title)
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "flexbox",
                      { staticClass: "common-header" },
                      [
                        _c("flexbox", { staticClass: "header-left" }, [
                          _c("span", { staticClass: "time-circle" }, [
                            _c("span", { staticClass: "wk wk-l-time" }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "time-text" }, [
                            _c("div", { staticClass: "text-up" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formattedTime(
                                    _vm.detail.start_time ||
                                      _vm.todayDetailData.startTime
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-time" }, [
                              _vm._v("开始时间"),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("flexbox", { staticClass: "header-right" }, [
                          _c("i", { staticClass: "el-icon-remove" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "time-text" }, [
                            _c("div", { staticClass: "text-up" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formattedTime(
                                    _vm.detail.end_time ||
                                      _vm.todayDetailData.endTime
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-time" }, [
                              _vm._v("结束时间"),
                            ]),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "common-content" },
                      [
                        _c("div", { staticClass: "content-title" }, [
                          _vm._v("参与人"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "flexbox",
                          _vm._l(_vm.detail.owner_user_info, function (item) {
                            return _c("xr-avatar", {
                              key: item.id,
                              staticClass: "user-img",
                              attrs: {
                                id: item.id,
                                size: 32,
                                disabled: false,
                                name: item.realname,
                                src: item.img || item.thumb_img,
                                trigger: "hover",
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "common-bootom" }, [
                      _c(
                        "div",
                        { staticClass: "type_time" },
                        [
                          _c("p", [_vm._v("提前提醒时间：")]),
                          _vm._v(" "),
                          _vm._l(_vm.noticeList, function (notice, index) {
                            return _c("span", { key: index }, [
                              index != 0
                                ? _c("span", [_vm._v("、")])
                                : _vm._e(),
                              _vm._v(
                                "提前" +
                                  _vm._s(notice.value) +
                                  _vm._s(_vm.timeList[notice.type]) +
                                  "提醒"
                              ),
                            ])
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "common-foot" }, [
                      _vm.relatedCount > 0
                        ? _c("div", { staticClass: "section__hd" }, [
                            _c("i", { staticClass: "wukong wukong-relevance" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "相关信息(" + _vm._s(_vm.relatedCount) + ")"
                              ),
                            ]),
                          ])
                        : _c("p", [_vm._v("暂无相关信息")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "section_scroll" }, [
                        _c(
                          "div",
                          [
                            _vm._l(
                              _vm.detail.customerList,
                              function (item, itemIndex) {
                                return _c("related-business-cell", {
                                  key: item.customerId,
                                  attrs: {
                                    data: item,
                                    "cell-index": itemIndex,
                                    "show-foot": false,
                                    type: "customer",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.checkRelatedDetail(
                                        item,
                                        "customer"
                                      )
                                    },
                                  },
                                })
                              }
                            ),
                            _vm._v(" "),
                            _vm._l(
                              _vm.detail.contactsList,
                              function (item, itemIndex) {
                                return _c("related-business-cell", {
                                  key: item.contactsId,
                                  attrs: {
                                    data: item,
                                    "cell-index": itemIndex,
                                    "show-foot": false,
                                    type: "contacts",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.checkRelatedDetail(
                                        item,
                                        "contacts"
                                      )
                                    },
                                  },
                                })
                              }
                            ),
                            _vm._v(" "),
                            _vm._l(
                              _vm.detail.contractList,
                              function (item, itemIndex) {
                                return _c("related-business-cell", {
                                  key: item.contractId,
                                  attrs: {
                                    data: item,
                                    "cell-index": itemIndex,
                                    "show-foot": false,
                                    type: "contract",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.checkRelatedDetail(
                                        item,
                                        "contract"
                                      )
                                    },
                                  },
                                })
                              }
                            ),
                            _vm._v(" "),
                            _vm._l(
                              _vm.detail.businessList,
                              function (item, itemIndex) {
                                return _c("related-business-cell", {
                                  key: item.businessId,
                                  attrs: {
                                    data: item,
                                    "cell-index": itemIndex,
                                    "show-foot": false,
                                    type: "business",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.checkRelatedDetail(
                                        item,
                                        "business"
                                      )
                                    },
                                  },
                                })
                              }
                            ),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c("create-event", {
        attrs: {
          "show-create": _vm.showCreate,
          "edit-all": _vm.editAll,
          "cus-check": _vm.cusCheck,
          "today-detail-data": _vm.detail,
          title: "编辑日程",
        },
        on: {
          createSuccess: _vm.handleSure,
          handleSure: _vm.handleSure,
          close: function ($event) {
            _vm.showCreate = false
          },
        },
      }),
      _vm._v(" "),
      _c("c-r-m-full-screen-detail", {
        attrs: {
          visible: _vm.showFullDetail,
          "crm-type": _vm.crmType,
          id: _vm.relationID,
        },
        on: {
          "update:visible": function ($event) {
            _vm.showFullDetail = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }